import { ReactNode } from 'react'

import { Stack } from '@mui/material'

import { AddTimeWindowAction } from './components/AddTimeWindowAction'
import { EditTimeWindows } from './components/EditTimeWindows'
import { FieldHeader } from './components/FieldHeader'
import { Menu } from './components/Menu'

import { useActions } from './hooks/useActions'

type Props = {
  label: string
  testId?: string
  value: [uui.domain.rm.TimeWindow?, uui.domain.rm.TimeWindow?]
  disabled: boolean
  error: boolean
  helperText: ReactNode
  validate: (force?: boolean) => void
  onChange: (value: [uui.domain.rm.TimeWindow?, uui.domain.rm.TimeWindow?]) => void
}

export function TimeWindows(props: Props) {
  const {
    label,
    testId = 'traffic-timeWindows',
    value,
    disabled,
    error,
    helperText,
    validate,
    onChange,
  } = props

  const actions = useActions(value, onChange)

  const addTimeWindowDisabled = value.length === 2
  const deleteAllTimeWindowsDisabled = value.length === 0

  return (
    <Stack data-testid={testId} data-trackid={testId} gap={2}>
      <FieldHeader
        label={label}
        action1={
          <AddTimeWindowAction
            onClick={actions.onAddTimeWindow}
            disabled={addTimeWindowDisabled}
            testId={`${testId}_add-time-window`}
          />
        }
        action2={
          <Menu
            onDeleteAllTimeWindows={actions.onDeleteAll}
            deleteAllTimeWindowsDisabled={deleteAllTimeWindowsDisabled}
          />
        }
      />

      <EditTimeWindows
        onUpdateTimeWindow={actions.onUpdateTimeWindow}
        onRemoveTimeWindow={actions.onRemoveTimeWindow}
        validate={validate}
        value={value}
        disabled={disabled}
        error={error}
        helperText={helperText}
      />
    </Stack>
  )
}
